import { render, staticRenderFns } from "./templalteIntro.vue?vue&type=template&id=526c5496&scoped=true"
import script from "./templalteIntro.vue?vue&type=script&lang=js"
export * from "./templalteIntro.vue?vue&type=script&lang=js"
import style0 from "./templalteIntro.vue?vue&type=style&index=0&id=526c5496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c5496",
  null
  
)

export default component.exports